import { useEffect, useRef } from "react"
import { CellularAutomata1D } from "../cellular-automata/1d/cellularAutomata1D"
import { Player } from "../performers/audio/player"

const COLORS = ["#090909", "#ffffff", "#a71c1c", "#ff8400"]

interface Props {
   automata: CellularAutomata1D
}

export default function CellularAutomataSketch({ automata }: Props) {
   const canvasRef = useRef<HTMLCanvasElement>(null)

   useEffect(() => {
      const canvas = canvasRef.current
      if (!canvas) return

      canvas.width = 400
      canvas.height = 400

      const ctx = canvas.getContext("2d")
      if (!ctx) return

      const player = new Player.Builder().withAutomata(automata).build()
      
      const draw = () => {
         const cellSize = 400 / automata.size
         
         for (let i = 0; i < 8; i++) automata.evolve()
         
         for (let y = 0; y < automata.size; y++) {
            for (let x = 0; x < automata.size; x++) {
               const state = automata.state[x]
               ctx.fillStyle = COLORS[state] || COLORS[0]
               ctx.fillRect(
                  Math.floor(x * cellSize), 
                  Math.floor(y * cellSize), 
                  Math.ceil(cellSize), 
                  Math.ceil(cellSize)
               )
            }
            automata.evolve()
         }
         automata.reset()
      }

      // Dibujar inmediatamente
      draw()
      
      // Animación a 10fps
      const interval = setInterval(() => {
         draw()
         player.play()
      }, 100)

      return () => {
         clearInterval(interval)
         player.stop()
      }
   }, [automata])

   return (
      <canvas 
         ref={canvasRef}
         width={400}
         height={400}
         style={{ display: "block", width: "100%", height: "100%" }}
      />
   )
}